import { Link } from "react-router-dom";
import PageMeta from "@/components/feature/PageMeta";
import SiteHeader from "@/components/feature/SiteHeader";
import SiteFooter from "@/components/feature/SiteFooter";

export default function NotFound() {
  return (
    <div className="flex min-h-screen flex-col bg-background-50">
      <PageMeta
        title="页面不存在 - 嫂子的诱惑"
        description="你访问的页面不存在或已被移除，请返回嫂子的诱惑首页浏览剧情介绍、演员资料与影视资讯。"
      />
      <SiteHeader />
      <main className="flex flex-1 items-center justify-center px-4 pb-16 pt-28">
        <div className="w-full max-w-xl text-center">
          <p className="font-heading text-6xl font-black text-primary-200 md:text-8xl">404</p>
          <h1 className="mt-4 font-heading text-2xl font-bold text-foreground-950">
            页面暂无或已被移除
          </h1>
          <p className="mt-3 text-sm leading-relaxed text-foreground-500">
            链接可能已经调整，也可能输入有误。你可以回到首页，或从分类页继续浏览站内内容。
          </p>
          <div className="mt-7 flex flex-col justify-center gap-3 sm:flex-row">
            <Link
              to="/"
              className="inline-flex items-center justify-center gap-2 whitespace-nowrap rounded-full bg-primary-500 px-6 py-3 text-sm font-medium text-background-50 transition-colors hover:bg-primary-600"
            >
              <i className="ri-home-4-line text-base" />
              返回首页
            </Link>
            <Link
              to={`/category/${encodeURIComponent("剧情介绍")}`}
              className="inline-flex items-center justify-center gap-2 whitespace-nowrap rounded-full border border-background-300 px-6 py-3 text-sm text-foreground-700 transition-colors hover:border-primary-300 hover:text-primary-700"
            >
              浏览剧情介绍
            </Link>
          </div>
        </div>
      </main>
      <SiteFooter />
    </div>
  );
}